import React from "react";

// Sélecteur de course pour les pages overlay stream — coin haut-gauche,
// fond semi-transparent pour rester lisible par-dessus n'importe quel
// contenu vidéo. Une fois la source OBS configurée avec la bonne URL
// (?category=women1), ajouter &hide=1 pour le masquer définitivement —
// le choix reste piloté par le paramètre d'URL, pas par cet élément.
export default function StreamControls({ categories, category, onCategoryChange, hidden, children }) {
    if (hidden) return null;
    return (
        <div
            style={{
                position: "fixed",
                top: 12,
                left: 12,
                zIndex: 1000,
                display: "flex",
                gap: 8,
                alignItems: "center",
                background: "rgba(0,0,0,0.55)",
                padding: "6px 10px",
                borderRadius: 8,
                fontFamily: "sans-serif",
                fontSize: 13,
                color: "#fff",
            }}
        >
            <select
                value={category || ""}
                onChange={(e) => onCategoryChange(e.target.value)}
                style={{ fontSize: 13, padding: "2px 4px" }}
            >
                <option value="">— choisir une course —</option>
                {categories.map((c) => (
                    <option key={c} value={c}>
                        {c}
                    </option>
                ))}
            </select>
            {children}
        </div>
    );
}
